import { AxiosResponse } from 'axios';
import { axiosIntance } from '../../../config/ApiConfig';
import { GeneralPurchase } from '../../../types/generalPurchase/GeneralPurchase';

export const GeneralPurchaseRepository = {
  create: (form: object): Promise<AxiosResponse<GeneralPurchase>> => {
    return axiosIntance.post('/generalPurchase', form);
  },
  update: (form: object): Promise<AxiosResponse<GeneralPurchase>> => {
    return axiosIntance.put('/generalPurchase', form);
  },
  delete: (form: object): Promise<AxiosResponse<{ sucess: boolean }>> => {
    return axiosIntance.delete('/generalPurchase', { data: form });
  },
};
